/* eslint-disable no-eval */
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Form, Input, Button, message } from 'antd';
import classnames from 'classnames';
import RegionCode from '@liepin/cnpm-react-regioncode-pc';
import localCookie from '@liepin/native-sweet-fe'
import { sendByTel, loginByTel } from '@liepin/js-login-api-fe'
import { SmsCountdown } from '../../modules/const';
import SvgDownArrow from '../../image/down-arrow.svg';
import useLogin from '../../hooks/use-login';
import styled from './index._less';

const chinaCodeValue = '0086';

export default () => {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [formData, setFormData] = useState({}); // 预留的初始值
  const dropdownRef = useRef();
  const regionCodeRef = useRef();
  const [form] = Form.useForm();
  const timer = useRef<any>();
  const { checkedAgreement, isModal, loginIndexMark, loginSuccess, loginError } = useLogin();
  const localTimestamp = useRef(Number(localCookie.get(SmsCountdown)))
  const [countDown, setCountDown] = useState(localTimestamp.current ? Math.round((localTimestamp.current - Date.now()) / 1000) : 0)
  const [showRegionCode, setShowRegionCode] = useState(false);
  const [fetchSmsCode, setFetchSmsCode] = useState(false); // 是否获取短信验证码中
  const [regionClientRect, setRegionClientRect] = useState<any>({ left: 0, top: 0 });
  const [regionCode, setRegionCode] = useState({ // 默认中国
    codeShow: '+86',
    codeValue: '',
    name: '中国',
    pinyin: 'zhongguo',
    regex: '/^1[2-9]\\d{9}$/',
  });

  const $loginRegionCodeSelector = `login-region-code-show-${loginIndexMark}`;

  const startCountDown = useCallback(() => {
    if (localTimestamp.current > Date.now()) {
      timer.current && clearInterval(timer.current)
      const getCountDown = () => {
        const end = Math.round((localTimestamp.current - Date.now()) / 1000)
        if (end <= 0) {
          clearInterval(timer.current)
          setCountDown(0)
        } else {
          setCountDown(end)
        }
      }
      getCountDown();
      timer.current = setInterval(getCountDown, 1000)
    }
  }, [localTimestamp, timer, setCountDown])

  // 倒计时
  useEffect(() => {
    countDown > 0 && startCountDown()
    return () => {
      timer.current && clearInterval(timer.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSendSmsCode = useCallback(async () => {
    const values = await form.validateFields();
    if (!values['tel']) {
      message.error('请输入手机号');
      return
    }
    if (!eval(regionCode.regex).test(values['tel'])) {
      message.error('请输入正确的手机号');
      return
    }
    try {
      if (countDown > 0 || fetchSmsCode) {
        return;
      }
      setFetchSmsCode(true)
      const values = await form.validateFields(['tel']);
      const tel = `${regionCode.codeValue === chinaCodeValue ? '' : regionCode.codeValue}${values.tel}`;
      sendByTel({ tel })
        .then(() => {
          localTimestamp.current = Date.now() + 60 * 1000
          localCookie.set(SmsCountdown, localTimestamp.current)
          startCountDown()
          setFetchSmsCode(false)
          message.success('发送成功.')
        })
        .catch(({ msg }) => {
          setFetchSmsCode(false)
          msg && message.error(msg)
        })
    } catch (error) {
      setFetchSmsCode(false)
    }
  }, [countDown, form, regionCode.codeValue, localTimestamp, fetchSmsCode, setFetchSmsCode, startCountDown])

  const handleLogin = useCallback(async () => {
    try {
      const values = await form.validateFields();
      if (!values['tel']) {
        message.error('请输入手机号');
        return
      }
      if (!eval(regionCode.regex).test(values['tel'])) {
        message.error('请输入正确的手机号');
        return
      }
      if (!values['smsCode']) {
        message.error('请输入短信验证码');
        return
      }

      if (!checkedAgreement) {
        message.error('请阅读并勾选同意猎聘相关服务协议');
        return;
      }
      const submitData = {
        ...values,
        tel: `${regionCode.codeValue === chinaCodeValue ? '' : regionCode.codeValue}${values.tel}`,
        'area-code': regionCode.codeValue,
      }
      loginByTel(submitData)
        .then(loginSuccess)
        .catch(loginError)
    } catch (error) {
    }
  }, [form, checkedAgreement, regionCode.codeValue, loginSuccess, loginError])

  const getSmscode = useCallback(() => {
    return (
      <div
        onClick={handleSendSmsCode}
        className={classnames('get-smscode-btn', { 'get-smscode-btn-active': !(countDown > 0) })}
      >{
          countDown > 0 ? `重新获取 (${countDown}S)` : '获取验证码'
        }</div>
    )
  }, [countDown, handleSendSmsCode])

  const handleChangeRegionCode = useCallback((e) => {
    setRegionCode(e)
    setTimeout(() => {
      setShowRegionCode(false);
      // 如果输入的有手机号，当切换国家时触发表单校验
      if (form.getFieldValue('tel')) {
        form.validateFields(['tel'])
      }
    })
  }, [setRegionCode, setShowRegionCode, form])

  // 获取国家弹窗定位距离
  const getRegionClientRect = useCallback(() => {
    const clientDom = document.querySelector(`#${$loginRegionCodeSelector}`)
    let clientRect = null;
    if (clientDom) {
      clientRect = clientDom.getBoundingClientRect()
      setRegionClientRect(clientRect);
    }
  }, [setRegionClientRect, $loginRegionCodeSelector])

  useEffect(() => {
    getRegionClientRect();
  }, [getRegionClientRect, showRegionCode])

  // 动态计算国家弹窗定位距离
  useEffect(() => {
    getRegionClientRect();
    window.addEventListener('resize', getRegionClientRect, false);
    window.addEventListener('scroll', getRegionClientRect, false);
    return () => {
      window.removeEventListener('resize', getRegionClientRect)
      window.removeEventListener('scroll', getRegionClientRect)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 国家选择
  useEffect(() => {
    const handleDocumentClick = (event) => {
      const { target } = event;
      if (regionCodeRef.current && (target === regionCodeRef.current || regionCodeRef.current.contains(target))) {
        // 点击已选项
        setShowRegionCode(e => !e);
      } else if (dropdownRef.current && (target === dropdownRef.current || dropdownRef.current.contains(target))) {
        // 点击浮层
        setShowRegionCode(true);
      } else {
        // 点击其他地方
        setShowRegionCode(false);
      }
    };
    document.addEventListener('click', handleDocumentClick, false);
    return () => document.removeEventListener('click', handleDocumentClick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectRegionCode = useCallback(() => {
    return (
      <>
        <div
          id={$loginRegionCodeSelector}
          className="select-region-code"
        >
          <div className="code-show" ref={regionCodeRef}>
            <div className="code">{regionCode.codeShow}</div>
            <div
              className={classnames('arrow-icon', { 'arrow-icon-transform': showRegionCode })}
            ><SvgDownArrow /></div>
          </div>
          {
            showRegionCode
              ? <div
                ref={dropdownRef}
                className="region-code-select-modal"
                style={{ left: regionClientRect.left, top: regionClientRect.top - 418 }}
              >
                <RegionCode
                  onChange={(e) => handleChangeRegionCode(e)}
                />
              </div>
              : ''
          }
        </div>
      </>
    );
  }, [$loginRegionCodeSelector, regionCodeRef, dropdownRef, regionCode, regionClientRect, showRegionCode, handleChangeRegionCode])

  return (
    <>
      <div className={classnames('login-container', {'login-container-component': !isModal })}>
        <Form
          form={form}
          initialValues={formData}
          size="large"
          name="horizontal_login"
          layout="inline"
        >
          <Form.Item
            name="tel"
            className="login-form-item-tel"
            rules={[{
              validator: (rule, value) => {
                return Promise.resolve()
              }
            }]}
          >
            <Input
              data-nick="login-phone"
              placeholder="手机号"
              addonBefore={selectRegionCode()}
              autoComplete="off"
              size="large"
            />
          </Form.Item>
          <Form.Item
            className="login-form-item-smscode"
            name="smsCode"
            rules={[{
              required: true,
              validator: (rule, value) => {
                return Promise.resolve()
              }
            }]}
          >
            <Input
              data-nick="login-smscode"
              placeholder="短信验证码"
              addonAfter={getSmscode()}
              autoComplete="off"
              size="large"
            />
          </Form.Item>
          <Button onClick={handleLogin} shape="round" className="login-submit-btn-bottom" size="large" type="primary">登录/注册</Button>
        </Form>
      </div>
      <style jsx>{styled}</style>
    </>
  )
}
